import {svgIconWrapper} from '../svg-icon-wrapper';

import InvoiceRegular from './invoice-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <InvoiceRegular {...props} />;
}
SvgComponent.iconName = 'invoiceRegular';

export const InvoiceRegularIcon = svgIconWrapper(SvgComponent);
